var map = {
	"./asktug.svg": 99551,
	"./cloud-dev.svg": 65868,
	"./cloud1.svg": 65760,
	"./cloud2.svg": 89539,
	"./cloud3.svg": 18461,
	"./cloud4.svg": 5160,
	"./cloud5.svg": 8503,
	"./cloud6.svg": 93624,
	"./cloud7.svg": 77229,
	"./contributor.svg": 29313,
	"./deploy.svg": 33484,
	"./doc1.svg": 46174,
	"./doc10.svg": 46712,
	"./doc11.svg": 43079,
	"./doc2.svg": 50404,
	"./doc3.svg": 72780,
	"./doc4.svg": 22060,
	"./doc5.svg": 70379,
	"./doc6.svg": 37932,
	"./doc7.svg": 86912,
	"./doc8.svg": 32772,
	"./doc9.svg": 39251,
	"./docHome.svg": 64924,
	"./events.svg": 72787,
	"./go.svg": 77042,
	"./java.svg": 39267,
	"./maintain.svg": 70780,
	"./ossinsight.svg": 11225,
	"./pablo-book-lover.svg": 18986,
	"./papers.svg": 16450,
	"./python.svg": 66030,
	"./tidb-banner.svg": 54969,
	"./tidb-cloud-banner.svg": 33306,
	"./tidb-cloud-tune.svg": 82430,
	"./users.svg": 50795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97802;